import { useEffect, useState } from "react";

// Keeps the typed text (so "0." and "-" work) and saves a number when the field loses focus.
export const RuleNum = ({ value, onChange, testid, w = 80 }) => {
  const [text, setText] = useState(value ?? "");
  useEffect(() => { setText(value ?? ""); }, [value]);
  const commit = () => {
    const n = Number(String(text).replace(",", "."));
    if (String(text).trim() === "" || Number.isNaN(n)) setText(value ?? "");
    else if (n !== value) onChange(n);
  };
  return (
    <input className="lg-input lg-mini" style={{ width: w, minWidth: 0 }} inputMode="decimal" value={text}
      onChange={(e) => setText(e.target.value)} onBlur={commit} onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()} data-testid={testid} />
  );
};
